/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-template-curly-in-string */
import * as React from "react";
import { useState, useEffect } from "react";
import {
  Button,
  Col,
  Form,
  Row,
  Spin,
} from "antd";
import "../../pages/home/ProjectDetail/Detail.css";
import dayjs from "dayjs";
import NoData from "../../images/noData.svg";
import DownloadIcon from "../../images/IconDownload.svg";
import { GetFileExport } from "../../api/detailProject";
import { GetDataDetailDescription } from "../../api/APIDescriptionDetail";
import { openNotificationWithIcon } from "../../Function";
import { useSelector } from "react-redux";
import { exportFileBill } from "../../constants";
import ModalLogDetail from "../home/ProjectDetail/ModalLogDetail";
import FormConfirmDescription from "./FormConfirmDescription";
import TableDetailDescription from "./TableDetailDescription";

const validateMessages = {
  required: "Không được để trống!",
  types: {
    email: "${label} is not a valid email!",
    number: "${label} is not a valid number!",
  },
  pattern: {
    mismatch: "Chỉ được nhập số nguyên",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};

const ProjectDetailDescription = () => {
  const [loading, setLoading] = React.useState(true);
  const [loadingConfirm, setLoadingConfirm] = useState(false);

  const [isOpenModalLogDetail, setIsOpenModalLogDetail] = React.useState(false);
  const [isOpenExpectedRevenue, setIsOpenExpectedRevenue] =
    React.useState(false);
  const [isOpenEditExpectedRevenue, setIsOpenEditExpectedRevenue] =
    React.useState(false);
  const [isOpenBtnEditExpectRevenue, setIsOpenBtnEditExpectRevenue] =
    useState(false);

  const [checkExpectedRevenue, setCheckExpectedRevenue] = React.useState(false);

  const [listClientOfUser, setListClientOfUser] = useState([]);
  const [listDataDep, setListDataDep] = React.useState([]);
  const [listDataProjectOfDep, setListDataProjectOfDep] = React.useState([]);

  const [dataLogDetail, setDataLogDetail] = useState();
  const [userRole, setUserRole] = React.useState("");

  const [dataDetailProject, setDataDetailProject] = useState([]);
  const [dataBasicProject, setDataBasicProject] = useState();
  const [valuesDetail, setValuesDetail] = useState();

  const [formGetDataDetail] = Form.useForm();
  const [formExpectedRevenue] = Form.useForm();
  const [lsPermissions, setLsPermissions] = useState([]);
  const [idProjectDownload, setIdProjectDownload] = useState();

  const [listDisable, setListDisable] = useState([]);

  const [loadingBtnDownloadFile, setLoadingBtnDownloadFile] = useState(false);

  const [onOpenColumns, setOnOpenColumns] = useState(false)

  const [titleBtn, setTitleBtn] = useState("VIEW ALL")

  const [dataDetailListDescription, setDataDetailListDescription] = useState([]);

  const userInfo = useSelector((state) => state.getUserInfo.userInfo);

  // State theo dõi khả năng hiển thị column
  const [showAllColumns, setShowAllColumns] = useState(false);

  // Cập nhật giá tri tổng tiền của một project
  const [valueTotalMoney, setValueTotalMoney] = useState(0);

  // Set 3 giá trị id_project, year, month khi chọn dự án
  const [idProjectDescription, setIdProjectDescription] = useState();
  const [year, setYear] = useState();
  const [month, setMonth] = useState();

  // Hàm cập nhật giá trị tổng tiền một project
  const updateTotalMoney = (newValue) => {
    setValueTotalMoney(newValue);
  };

  const [isShowBtnEdit, setIsShowBtnEdit] = useState(false);

  const toggleBtnEdit = () => {
    setIsShowBtnEdit((prev) => !prev);
  }

  useEffect(() => {
    if (userInfo) {
      const arrPermission = userInfo.permission.map(item => item.name);
      setLsPermissions([...arrPermission]);
    }

  }, [userInfo]);

  const onFinishImport = (values) => {
    setLoadingConfirm(true);
    setIsOpenExpectedRevenue(false);
    const yearDetail = values.date.$y;
    const dateObject = new Date(values.date); // Convert to Date object
    const valueMonth = dateObject.getMonth() + 1; // getMonth() returns 0-based, so add 1
    const valueIdProject = values.project;

    // Reset dữ liệu bảng trước khi fetch
    setDataDetailListDescription([]);

    // Reset tổng tiền trước khi fetch
    setValueTotalMoney(0);

    // Set giá trị id_project, year, month
    setIdProjectDescription(valueIdProject);
    setYear(yearDetail);
    setMonth(valueMonth);

    GetDataDetailDescription({
      id_project: valueIdProject,
      year: yearDetail,
      month: valueMonth,
    })
      .then((res) => {
        setValuesDetail(values);
        // Đảm bảo listDescription là mảng, tránh undefined
        setDataDetailListDescription(res.data?.listDescription || []);
        setDataBasicProject(res.data?.project);
        setIdProjectDownload(values?.project);

        // Set giá trị tổng tiền
        setValueTotalMoney(res?.data?.sum_project);

        if (res.data.detail_project.length > 1) {
          setDataDetailProject(res.data?.detail_project);
          const checkDealStage = res.data?.detail_project.filter(
            (item) => item.dealstage === 2
          );
          if (checkDealStage.length < 1) {
            setIsOpenBtnEditExpectRevenue(false);
          } else {
            setIsOpenBtnEditExpectRevenue(true);
          }
        } else {
          openNotificationWithIcon("warning", "Dự án chưa có doanh thu dự kiến");
          setDataDetailProject(res.data.detail_project);
        }
        setIsOpenEditExpectedRevenue(false);
        setLoadingConfirm(false);
      })
      .catch((err) => {
        setLoadingConfirm(false);
      });
  };

  useEffect(() => {
    if (dataDetailProject.length === 1) {
      setCheckExpectedRevenue(true);
    } else {
      setCheckExpectedRevenue(false);
    }
  }, [dataDetailProject]);

  // const GetFileBill = () => {
  //   setLoadingBtnDownloadFile(true);
  //   GetFileExport({
  //     id: idProjectDownload,
  //   }).then((res) => {
  //     let file_path = `${exportFileBill}?id=${idProjectDownload}`;
  //     let a = document.createElement("A");
  //     a.href = file_path;
  //     a.download = file_path.substr(file_path.lastIndexOf("/") + 1);
  //     document.body.appendChild(a);
  //     a.click();
  //     document.body.removeChild(a);
  //     setLoadingBtnDownloadFile(false);
  //   }).catch((err) => {
  //     setLoadingBtnDownloadFile(false);
  //     openNotificationWithIcon("error", err.data.message);
  //   });
  // };

  useEffect(() => {
    if (userInfo !== undefined && userInfo.listDepOfProject.length > 0) {
      setLoading(false);
      // Array of department id
      let arrDepart = [];
      userInfo.listProject.forEach((item) => arrDepart.push(item.depart_id));

      // Array of department unique id
      var unique = arrDepart.filter(
        (value, index, array) => array.indexOf(value) === index
      );

      // Department list have project
      const listDepart = userInfo.listDepOfProject.filter((item) =>
        unique.includes(item.depart_id)
      );

      setListDataDep(listDepart);
      setListClientOfUser(userInfo.listClient);
      // setListDataProjectOfDep(userInfo.listProject);
      ChooseDepartment(listDepart[0].depart_id);
      if (listDepart.length > 1) {
        formGetDataDetail.setFieldValue("department", listDepart[0].depart_id);
        setUserRole("Admin");
      } else {
        formGetDataDetail.setFieldValue("department", listDepart[0].depart_id);
        setUserRole("Member");
      }
    } else {
      setLoading(false);
    }
  }, [userInfo]);

  const ChooseDepartment = (e) => {
    if (e !== undefined) {
      formGetDataDetail.setFieldValue("client_code", undefined);
      formGetDataDetail.setFieldValue("department", e);
      const listFilter = userInfo.listClient.filter(
        (item) => item.depart_id === e
      );
      ChooseClient(listFilter[0].id);
      if (listFilter.length > 0) {
        formGetDataDetail.setFieldValue("client_code", listFilter[0].id);
        setListClientOfUser(listFilter);
      } else {
        setListClientOfUser(listClientOfUser);
      }
    } else {
      setListClientOfUser([]);
      setListDataProjectOfDep([]);
      formGetDataDetail.setFieldValue("project", undefined);
      formGetDataDetail.setFieldValue("client_code", undefined);
    }
  };

  const ChooseClient = (e) => {
    formGetDataDetail.setFieldValue("project", undefined);
    const idDepart = formGetDataDetail.getFieldValue("department");
    const listFilter = userInfo.listProject.filter(
      (item) => item.client_id === e
    );
    const newListFilter = listFilter.filter(
      (item) => item.depart_id === idDepart
    );
    if (newListFilter.length > 0) {
      formGetDataDetail.setFieldValue("project", newListFilter[0].id);
      setListDataProjectOfDep(newListFilter);
    } else {
      setListDataProjectOfDep(listDataProjectOfDep);
    }
  };

  useEffect(() => {
    formExpectedRevenue.resetFields();
    formGetDataDetail.setFieldValue("date", dayjs());
  }, []);

  useEffect(() => {
    const listMonth = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    const monthNow = dayjs().format("M");
    const listInputDisable = [];
    if (isOpenEditExpectedRevenue === true) {
      for (let i = 0; i < listMonth.length; i++) {
        if (listMonth[i] < monthNow) {

          listInputDisable.push(listMonth[i]);
        }
      }
    }
    setListDisable(listInputDisable);
  }, [isOpenEditExpectedRevenue]);

  const toggleColumnsVisibility = () => {
    setShowAllColumns(prev => !prev);
    setOnOpenColumns(!onOpenColumns)
    if (onOpenColumns === true) {
      setTitleBtn("VIEW ALL")
    } else {
      setTitleBtn("HIDDEN")
    }
  };

  // useEffect(() => {
  //   if (dataDetailListDescription.length > 0) {
  //     console.log("Table data updated:", dataDetailListDescription);
  //   }
  // }, [dataDetailListDescription]);

  return (
    <>
      {loading ? (
        <div className="loading-detail-pj">
          <Spin spinning={loading} size="large"></Spin>
        </div>
      ) : (
        <div style={{ position: "relative", width: "100%" }}>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "12vh",
            }}
          >
            <div className="get-detail-pj">
              <FormConfirmDescription
                formGetDataDetail={formGetDataDetail}
                onFinishImport={onFinishImport}
                validateMessages={validateMessages}
                ChooseDepartment={ChooseDepartment}
                userRole={userRole}
                userInfo={userInfo}
                listDataDep={listDataDep}
                ChooseClient={ChooseClient}
                listClientOfUser={listClientOfUser}
                listDataProjectOfDep={listDataProjectOfDep}
                loadingConfirm={loadingConfirm}
              />
              <Row className="btn-revenue-row-op" style={{ marginTop: "0.5%", marginLeft: "-17px" }}>
                <Col span={11} style={{
                  display: "flex",
                }}>

                  {/* {dataBasicProject ? (
                    <Button
                      htmlType="button"
                      loading={loadingBtnDownloadFile}
                      className="btn-downloadFile"
                      onClick={GetFileBill}
                    >
                      DOWNLOAD FILE{" "}
                      <img
                        style={{ marginLeft: 8 }}
                        src={DownloadIcon}
                        alt=""
                      ></img>
                    </Button>
                  ) : null} */}

                  {lsPermissions.includes(
                    "View full Operation"
                  ) === true && dataDetailListDescription.length > 0 ? (

                    <Button
                      className="btn-revenue"
                      onClick={toggleColumnsVisibility}
                      style={{ color: "#337aee", width: "163.56px", paddingLeft: "0%", }}
                    >
                      {titleBtn}
                    </Button>
                  ) : null}

                  {lsPermissions.includes(
                    "Unlock detail description Operation"
                  ) === true && dataDetailListDescription.length > 0 ? (

                    <Button
                      className="btn-revenue"
                      style={{ color: "#337aee", width: "163.56px", paddingLeft: "0%", }}
                      onClick={toggleBtnEdit}
                    >
                      {isShowBtnEdit ? "HIDDEN EDIT" : "UNLOCK EDIT" }
                    </Button>
                  ) : null}

                </Col>

                <Col span={12} style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  paddingRight: "2%",
                }}>
                  <p className="pSaoKeRightTop">
                    TỔNG TIỀN DỰ ÁN: {valueTotalMoney.toLocaleString('en-US')}
                  </p>
                </Col>


              </Row>
            </div>
          </div>

          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "12vh",
              marginTop: "20px",
            }}
          >
            <div className="information">
              <Row
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "0.3%",
                }}
              >
                <Col span={8} className="center-col">
                  <div className="center-div">
                    <p className="text-basic">
                      Currency:{" "}
                      {dataBasicProject ? dataBasicProject.currency.code : null}
                    </p>
                  </div>
                </Col>
                <Col span={8} className="center-col">
                  <div className="center-div">
                    <p className="text-basic">
                      Market:{" "}
                      {dataBasicProject ? dataBasicProject.market.name : null}
                    </p>
                  </div>
                </Col>
                <Col span={8} className="center-col">
                  <div className="center-div">
                    {dataBasicProject ? (
                      <p className="text-basic">
                        Client Code: {dataBasicProject.client.name}
                      </p>
                    ) : (
                      <p className="text-basic">Client Code:</p>
                    )}
                  </div>
                </Col>
              </Row>
              <Row
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "0.5%",
                }}
              >
                <Col span={8} className="center-col">
                  <div className="center-div">
                    <p className="text-basic">
                      Product/Service:{" "}
                      {dataBasicProject
                        ? dataBasicProject.pdservice.code
                        : null}
                    </p>
                  </div>
                </Col>
                <Col span={8} className="center-col">
                  <div className="center-div">
                    {dataBasicProject ? (
                      <p
                        className="text-basic"
                      >
                        Bank Account: {dataBasicProject.bank.code}
                      </p>
                    ) : (
                      <p className="text-basic">Bank Account:</p>
                    )}
                  </div>
                </Col>
                <Col span={8} className="center-col">
                  <div className="center-div">
                    <p className="text-basic">
                      Deal owner:{" "}
                      {dataBasicProject ? dataBasicProject.dealown : null}
                    </p>
                  </div>
                </Col>
              </Row>
            </div>
          </div>

          <div className="table-sale-ope">
            {dataDetailListDescription.length > 0 ? (
              <TableDetailDescription
                key={`${idProjectDescription}-${year}-${month}`} // Change key to force re-render
                data={dataDetailListDescription}
                showAllColumns={showAllColumns}
                onOpenColumns={onOpenColumns}
                updateTotalMoney={updateTotalMoney}
                idProjectDescription={idProjectDescription}
                valueYear={year}
                valueMonth={month}
                isShowBtnEdit={isShowBtnEdit}
                style={{ width: "98%" }}
                scroll={{
                  x: onOpenColumns === true ? 3000 : null,
                  y: window.screen.availHeight > 850 ? "56vh" : "53vh",
                }}
                pagination={false}
                className="custom-table table-striped-rows"
                bordered
                rowClassName={(record, index) =>
                  index % 2 === 0 ? "table-row-light" : "table-row-dark"
                }
              />
            ) : null}

            {isOpenExpectedRevenue === false &&
              checkExpectedRevenue === true ? (
              <img src={NoData} alt="" style={{ marginTop: "10%" }}></img>
            ) : null}
          </div>

        </div>
      )}

      <ModalLogDetail
        isOpenModalLogDetail={isOpenModalLogDetail}
        setIsOpenModalLogDetail={setIsOpenModalLogDetail}
        dataLogDetail={dataLogDetail}
      />

    </>
  );
}

export default ProjectDetailDescription;
